import BrandMagnetScoreTree from './brandMagnetScoreTree'

export default BrandMagnetScoreTree
